export default __webpack_public_path__ + "static/media/bannerDesktop1.ff03752e.png";